export default __webpack_public_path__ + "static/media/orphanswords-ascent-01.588e9c9f.jpg";